export default "__VITE_ASSET__DnpWUFFk__"